const authUrl = 'https://auth.heytout.com';
const baseUrl = 'https://api.heytout.com';
//const baseUrl = 'localhost:3021';
export {
    baseUrl,
    authUrl
}

